import React, {useEffect, useId, useRef} from 'react';
import {toast} from 'react-toastify';

/** Keep the correction on the page; notify without moving users during background work. */
export default function IndividualErrorAlert({message, children, className = 'alert alert-danger', notify = 'offscreen', attempt = 0}: {
  message: string; children?: React.ReactNode; className?: string; notify?: 'always' | 'offscreen' | 'never'; attempt?: number;
}) {
  const alert = useRef<HTMLDivElement>(null);
  const id = useId();
  useEffect(() => {
    const element = alert.current;
    if (!element || !message || notify === 'never') return;
    const bounds = element.getBoundingClientRect();
    let top = 0, bottom = window.innerHeight, left = 0, right = window.innerWidth;
    for (let parent = element.parentElement; parent; parent = parent.parentElement) {
      const style = window.getComputedStyle(parent), rect = parent.getBoundingClientRect();
      if (/(auto|scroll|hidden|clip)/.test(style.overflowY || style.overflow)) { top = Math.max(top, rect.top); bottom = Math.min(bottom, rect.bottom); }
      if (/(auto|scroll|hidden|clip)/.test(style.overflowX || style.overflow)) { left = Math.max(left, rect.left); right = Math.min(right, rect.right); }
    }
    const visible = bounds.height > 0 && bounds.width > 0 && bounds.bottom > top && bounds.top < bottom && bounds.right > left && bounds.left < right;
    if (notify === 'offscreen' && visible) return;
    const toastId = `individual-error-${id}`;
    toast.error(<div><div>{message}</div><button type="button" className="btn btn-sm btn-outline-danger mt-2" onClick={() => {
      element.scrollIntoView?.({block:'center',behavior:'auto'});
      element.focus({preventScroll:true});
      toast.dismiss(toastId);
    }}>View error</button></div>, {toastId, autoClose:false, closeOnClick:false});
    return () => { toast.dismiss(toastId); };
  }, [message, notify, attempt, id]);
  return <div ref={alert} role="alert" tabIndex={-1} className={className}>{children || message}</div>;
}
